import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

export enum DialogSaveEventPositionResult {
  Save = 'save',
  Discard = 'discard',
}

/** closes with the user's choice, or with nothing when closed to keep moving the event */
@Component({
  selector: 'gc-dialog-save-event-position',
  templateUrl: './dialog-save-event-position.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Button, SvgIconComponent, TranslateDirective, TranslatePipe],
})
export class DialogSaveEventPositionComponent {
  private readonly ref = inject(DynamicDialogRef);

  protected readonly Result = DialogSaveEventPositionResult;

  public close(result?: DialogSaveEventPositionResult): void {
    this.ref.close(result);
  }
}
